import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import {
  combineValidators,
  composeValidators,
  hasLengthLessThan,
  isRequired,
  matchesPattern,
  hasLengthGreaterThan,
} from "revalidate";
import { toast } from "react-toastify";
import { RootStoreContext } from "../../app/stores/rootStore";
import TextInput from "../../app/common/form/TextInput";
import { IResendMailForm, IDocumentList } from "../../app/models/trackDocument";

const validate = combineValidators({
  contact: composeValidators(
    isRequired({ message: "El Contacto es obligatorio" }),
    hasLengthLessThan(257)({
      message: "El Contacto debe tener máximo 256 caracteres",
    }),
    hasLengthGreaterThan(4)({
      message: "El Contacto debe tener al menos 5 caracteres",
    }),
  )(),
  mail: composeValidators(
    isRequired({ message: "El Email es obligatorio" }),
    matchesPattern(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)({
      message: "Por favor digite un Email valido",
    }),
    hasLengthLessThan(257)({
      message: "El Email debe tener máximo 256 caracteres",
    }),
    hasLengthGreaterThan(5)({
      message: "El Email debe tener al menos 6 caracteres",
    }),
  )(),
});

interface IProps {
  document: IDocumentList;
}

const ResendMail:React.FC<IProps> = ({document}) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { resendMail } = rootStore.trackDocumentStore;
  const { loading } = rootStore.buttonLoadingStore;

  const [resendMailForm] = useState<IResendMailForm>({
    contact: "",
    mail: "",
  });

  const handleFinalFormSubmit = (values: IResendMailForm) => {
    if (
        resendMailForm.contact !== values.contact ||
        resendMailForm.mail !== values.mail
    ) {
      resendMail(values,document);
    } else toast.error("No ha hecho ningún cambio");
  };
  return (
    <div className="tabContentStyle">
      <FinalForm
        validate={validate}
        initialValues={resendMailForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Contacto</label>
              <Field
                name="contact"
                component={TextInput}
                defaultValue={resendMailForm.contact}
              />
              <label>Mail</label>
              <Field
                name="mail"
                component={TextInput}
                defaultValue={resendMailForm.mail}
              />
              <br />
              <Button
                loading={loading}
                disabled={loading}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Enviar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(ResendMail);
